import Component from 'react-pure-render/component';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import NumberUtils from 'portaltransparencia-common/libs/NumberUtils.js';
import ObraDetalheMedicaoImagem from './ObraDetalheMedicaoImagem.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import TableActionButton from 'portaltransparencia-common/components/TableActionButton.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react.js';
import { convertBase64toBlob } from 'portaltransparencia-common/libs/FileUtils.js';

export class ObraDetalheMedicao extends Component {
  static propTypes = {
    medicoes: PropTypes.object.isRequired,
    onDownload: PropTypes.func.isRequired,
    imagens: PropTypes.object.isRequired,
    findImagens: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      showImagens: false
    };
  }

  openPDFLaudoMedicao = data => {
    let blob = convertBase64toBlob(data, 'application/pdf');
    window.open(URL.createObjectURL(blob));
  };

  renderMedicoes = data => {
    const key =
      data.get('entidade') +
      '_' +
      data.get('exercicio') +
      '_' +
      data.get('idOrdemServico') +
      '_' +
      data.get('sequencia');

    const customActions = this.existsImages(data);

    return (
      <TableActions
        ref="row"
        key={key}
        data={data.get('arquivo')}
        onDownload={this.openPDFLaudoMedicao}
        customActions={customActions}
      >
        <td>{data.get('aditivo')}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td>{data.get('tipoAcompanhamento')}</td>
        <td>{NumberUtils.format(data.get('percentual'))} %</td>
        <td>{NumberUtils.format(data.get('acumulado'))} %</td>
      </TableActions>
    );
  };

  existsImages = data => {
    if (data.get('existeImagem') > 0) {
      return (
        <TableActionButton
          data={data}
          onClick={this.onShowImages}
          title="Visualizar Imagens"
          icon="fa fa-picture-o"
        />
      );
    }
    return false;
  };

  onShowImages = item => {
    const { findImagens } = this.props;

    findImagens(
      item.get('entidade'),
      item.get('exercicio'),
      item.get('idOrdemServico'),
      item.get('sequencia')
    ).then(() => this.openImages());
  };

  openImages = () => {
    this.setState({
      showImagens: true
    });
  };

  onClose = () => {
    this.setState({
      showImagens: false
    });
  };

  render() {
    const { medicoes, imagens } = this.props;
    const { showImagens } = this.state;

    return (
      <section>
        <ObraDetalheMedicaoImagem
          imagens={imagens}
          show={showImagens}
          onClose={this.onClose}
        />
        <div className="panel-table-outer">
          <table className="panel-table striped fancy">
            <TableHeader empty={medicoes.isEmpty()}>
              <tr>
                <th>Contrato/Aditivo</th>
                <th>Data</th>
                <th>Tipo Acompanhamento</th>
                <th>Medição</th>
                <th>Acumulado</th>
                <th></th>
              </tr>
            </TableHeader>
            <tbody>{medicoes.map(this.renderMedicoes)}</tbody>
          </table>
        </div>
      </section>
    );
  }
}

export default ObraDetalheMedicao;
